import { render, staticRenderFns } from "./contacts-profile-update.vue?vue&type=template&id=913f809a&"
import script from "./contacts-profile-update.vue?vue&type=script&lang=js&"
export * from "./contacts-profile-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports